/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifTheme,
  MotifErrorMessage,
  MotifIcon,
} from "@ey-xd/motif-react";
import "./CreateSkuModal.scss";
import InputBox from "../../components/Form/InputBox/InputBox";
import SelectBox from "../../components/Form/SelectBox/SelectBox";
import { isEmpty, ltrimString } from "../../utils/Validator";
import {
  CONSUMPTION_MANAGER,
  MAX_LENGTH,
  MAX_LENGTH_SKU_NAME,
  REQUIRED_COST_METRICS_AVIALBLE,
  SKU_NAME_HELPER_TEXT,
} from "../../Constant";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useNavigate, useParams } from "react-router";
import { fetchSkuConfigData } from "../../store/slices/CTDBSkuConfigSlice";
import {
  AUTO_PROVISION,
  AUTO_PROVISION_PLACEHOLDER,
  COST_INTERVAL,
  COST_INTERVAL_PLACEHOLDER,
  COMMERCIAL_PLACEHOLDER,
  COMMERCIAL_STATUS,
  COST,
  COST_CATEGORY,
  COST_CATEGORY_PLACEHOLDER,
  COST_MACRO_CATEGORY,
  COST_MACRO_CATEGORY_PLACEHOLDER,
  EMPIRE_CODE_PLACEHOLDER,
  MINIMUM_SELECTABLE_INCREMENT,
  RETURNABLE,
  RETURNABLE_PLACEHOLDER,
  SKU_LONG_DESCRIPTION,
  SKU_NAME,
  SKU_RELATION,
  SKU_RELATION_PLACEHOLDER,
  COST_METRIC,
  COST_METRIC_PLACEHOLDER,
  NSR,
  BILLING_TYPE_STATUS,
  GLOBAL_RISK_MANAGER,
  LOCAL_RISK_MANAGER,
  PRODUCT_APPROVER,
  PROVISIONING_TEAM,
  INDEXATION,
  INDEXATION_PLACEHOLDER,
  PREVENT_SKU_SUBMISSION,
  MISSING_FIELDS_ERROR,
  SKU_CREATION_MESSAGE,
} from "./Constants";
import { ORDER_ACKNOWLEDGEMENT } from "../CTProductCostSetup/Constants";
import Loader from "../../components/Loader";
import { CreateSkuFormValues } from "./type";
import { mapSKuDataWithApi, validateFormFields } from "./helper";
import {
  createSku,
  resetCreateSkuState,
} from "../../store/slices/CTDBCreateSkuSlice";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import { fetchSkuListAllData } from "../../store/slices/CTDBSkuListAllSlice";
import { formatUSDWithCommas, sortOptions } from "../../utils/common";
import { RichTextEditor } from "../../components/Form/RichTextEditor/RichTextEditor";
import MultiSelect from "../../components/MultiSelect/MultiSelect";
import { IconoirInfoCircle } from "@ey-xd/motif-icon";
import { fetchLatestSkuListData } from "../../store/slices/CTDBSkuListSlice";
import UserSearchSelect from "../../components/UserSearchSelect";
export interface ProxyOwner {
  Name: string;
  Email: string;
}

const CreateSkuModal = ({
  show = true,
  setShow,
  onSave,
  redirectToProductPreview = false,
  hasAnyProductError = false,
}: {
  show: boolean;
  setShow: (isVisible: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSave: (updatedComment: any) => void;
  redirectToProductPreview: boolean;
  hasAnyProductError?: boolean;
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [isSubmitSKULoading, setIsSubmitSKULoading] = useState(false);
  const [isSaveSKULoading, setIsSaveSKULoading] = useState(false);
  const navigate = useNavigate();
  const param = useParams();
  const productId = param.id;

  const [localRiskMng, setLocalRiskMng] = useState<ProxyOwner[] | null>([]);
  const [globalRiskMng, setGlobalRiskMng] = useState<ProxyOwner[] | [] | null>(
    [],
  );
  const [productApproverList, setProductApproverList] = useState<
    ProxyOwner[] | [] | null
  >([]);
  const [consumptionManagerList, setConsumptionManagerList] = useState<
    ProxyOwner[] | null
  >([]);
  const [deploymentApproverList, setDeploymentApproverList] = useState<
    ProxyOwner[] | [] | null
  >([]);
  const [costTypeRequiredError, setCostTypeRequiredError] = useState(false);
  const handleMyProductBtnClick =
    (productId: string | undefined) => (e: React.MouseEvent) => {
      if (!productId || !redirectToProductPreview) {
        setShow(false);
        return;
      }
      e.stopPropagation();
      navigate("/ct/product/" + productId + "/preview");
    };

  function padNumber(num: number, length: number = 3): string {
    const numberToPad = num + 1;
    return numberToPad.toString().padStart(length, "0");
  }
  const skuData = useSelector(
    (state: RootState) => state.CTDBSkuListSlice.latestSkuList,
  );

  const skuLastRecord = skuData?.Result?.[0]?.SkuId || "0";
  let lastSkuNumber = 0;
  if (skuLastRecord !== "0") {
    const skuNumber = skuLastRecord.split("-")[1];
    lastSkuNumber = parseInt(skuNumber, 10);
  }

  const skuTotalNumber = padNumber(lastSkuNumber);

  interface InitialValues {
    skuNumber: string;
    skuNumber_2: string;
    skuNumber_3: string;
    skuShortDescription: string;
    skuLongDescription: string;
    costCategory: string;
    chargingIncrement: string;
    returnable: string;
    costMacroCategory: string;
    minimumSelectableIncrement: string;
    cost: string;
    skuRelation: string[];
    autoProvision: string;
    commercialStatus: string;
    costMetric: string;
    CostMetricNSR: string;
    billingType: string;
    deploymentApprover: string;
    Indexation: string;
  }

  const initialValues: InitialValues = {
    skuNumber: "",
    skuNumber_2: "",
    skuNumber_3: "",
    skuShortDescription: "",
    skuLongDescription: "",
    costCategory: "",
    chargingIncrement: "",
    returnable: "",
    costMacroCategory: "",
    minimumSelectableIncrement: "",
    cost: "",
    skuRelation: [],
    autoProvision: "",
    commercialStatus: "sku_draft",
    costMetric: "",
    CostMetricNSR: "",
    billingType: "",
    deploymentApprover: "",
    Indexation: "",
  };
  const dispatch = useDispatch<AppDispatch>();

  const isconfigLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.isLoading,
  );
  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );
  const configErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.error,
  );

  const isSkuListLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.isLoading,
  );
  const skuListData = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.data,
  );
  const skuListErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.error,
  );
  const createSKUData = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.data,
  );
  const createSKUErrorAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.error,
  );

  useEffect(() => {
    if (param.id !== undefined && param.id !== null) {
      dispatch(fetchSkuConfigData());
    }
  }, []);

  useEffect(() => {
    dispatch(
      fetchSkuListAllData({
        search: "",
        productId: param.id || "", // Replace with actual product ID
        page: 1,
        record: 1000,
        sortOrder: "desc",
        sortColumn: "SkuId",
        exclude: "AutoTransact",
        skuRelation: true,
      }),
    );

    dispatch(
      fetchLatestSkuListData({
        search: "",
        productId: param.id || "", // Replace with actual product ID
        page: 1,
        record: 10,
        sortOrder: "desc",
        sortColumn: "SkuId",
      }),
    );
  }, [dispatch, param.id]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formFields, setFormFields] = useState<any>(initialValues);

  const errorInitail = {
    skuNumber: {
      isError: false,
      message: "",
      validation: ["required", "maxLength", "isAlphaNumeric"],
      label: "SKU Number",
      maxLengthLimit: 1,
    },
    skuNumber_2: {
      isError: false,
      message: "",
      validation: ["required", "maxLength", "isAlphaNumeric"],
      label: "SKU Number 2",
      maxLengthLimit: 1,
    },
    skuNumber_3: {
      isError: false,
      message: "",
      validation: ["required", "maxLength", "isAlphaNumeric"],
      label: "SKU Number 3",
      maxLengthLimit: 1,
    },
    skuShortDescription: {
      isError: false,
      message: "",
      validation: ["required"],
      label: SKU_NAME,
      maxLengthLimit: 64,
    },
    skuLongDescription: {
      isError: false,
      message: "",
      validation: ["required", "maxLength"],
      label: SKU_LONG_DESCRIPTION,
      maxLengthLimit: MAX_LENGTH,
    },
    costCategory: {
      isError: false,
      message: "",
      validation: ["required"],
      label: COST_CATEGORY,
    },
    chargingIncrement: {
      isError: false,
      message: "",
      validation: ["required"],
      label: COST_INTERVAL,
    },
    returnable: {
      isError: false,
      message: "",
      validation: ["required"],
      label: RETURNABLE,
    },
    costMacroCategory: {
      isError: false,
      message: "",
      validation: ["required"],
      label: COST_MACRO_CATEGORY,
    },
    minimumSelectableIncrement: {
      isError: false,
      message: "",
      validation: ["required", "isNumber", "isInteger", "isPositive"],
      label: MINIMUM_SELECTABLE_INCREMENT,
    },
    cost: {
      isError: false,
      message: "",
      validation: ["required"],
      label: COST,
    },
    skuRelation: {
      isError: false,
      message: "",
      validation: [""],
      label: SKU_RELATION,
    },
    autoProvision: {
      isError: false,
      message: "",
      validation: ["required"],
      label: AUTO_PROVISION,
    },
    commercialStatus: {
      isError: false,
      message: "",
      validation: ["required"],
      label: COMMERCIAL_STATUS,
    },
    billingType: {
      isError: false,
      message: "",
      validation: ["required"],
      label: BILLING_TYPE_STATUS,
    },
    costMetric: {
      isError: false,
      message: "",
      validation: ["required"],
      label: COST_METRIC,
    },
    CostMetricNSR: {
      isError: false,
      message: "",
      validation: [""],
      label: NSR,
    },
    deploymentApprover: {
      isError: false,
      message: "",
      validation: [""],
      label: PROVISIONING_TEAM,
    },
    Indexation: {
      isError: false,
      message: "",
      validation: ["validatePercentageRange"],
      label: INDEXATION,
    },
  };
  const [error, setError] = useState(errorInitail);

  const {
    skuNumber: skuNumberError,
    skuNumber_2: skuNumber_2Error,
    skuNumber_3: skuNumber_3Error,
    skuShortDescription: skuShortDescriptionError,
    skuLongDescription: skuLongDescriptionError,
    costCategory: costCategoryError,
    chargingIncrement: chargingIncrementError,
    returnable: returnableError,
    costMacroCategory: costMacroCategoryError,
    minimumSelectableIncrement: minimumSelectableIncrementError,
    cost: costError,
    skuRelation: skuRelationError,
    autoProvision: autoProvisionError,
    commercialStatus: commercialStatusError,
    billingType: billingTypeError,
    costMetric: costMetricError,
    CostMetricNSR: CostMetricNSRError,
    deploymentApprover,
    Indexation: IndexationError,
  } = error;

  const getSlicedSkuName = (name: string, value: string | string[]) => {
    if (name === "skuShortDescription" && value.length > MAX_LENGTH_SKU_NAME) {
      const slicedValue = value.slice(0, MAX_LENGTH_SKU_NAME);
      setFormFields(() => {
        return {
          ...formFields,
          [name]: slicedValue,
        };
      });
    }
  };

  const isValidForm = async (statusType: string) => {
    let isValid = true;
    const isNotDraft = statusType !== "sku_draft";
    // eslint-disable-next-line prefer-const
    for (let [key, value] of Object.entries(formFields)) {
      value = value || "";
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      const isErrorField = validateFormFields(
        key,
        //@ts-expect-error value is input field value
        value,
        error,
        setError,
        statusType,
        formFields,
      );
      if (isErrorField) {
        isValid = false;
      }
    }
    if (
      formFields.autoProvision === "0" &&
      deploymentApproverList?.length === 0 &&
      isNotDraft
    ) {
      isValid = false;
      setError((prevState: typeof errorInitail) => ({
        ...prevState,
        ["deploymentApprover"]: {
          isError: true,
          message: "",
          validation: ["required"],
          label: PROVISIONING_TEAM,
        },
      }));
    } else {
      setError((prevState: typeof errorInitail) => ({
        ...prevState,
        ["deploymentApprover"]: {
          isError: false,
          message: "",
          validation: [],
          label: PROVISIONING_TEAM,
        },
      }));
    }
    if (!isEmpty(formFields.costCategory) && isEmpty(formFields.costMetric)) {
      isValid = false;
      setError((prevState: typeof errorInitail) => ({
        ...prevState,
        ["costMetric"]: {
          isError: true,
          message: `${COST_METRIC}  is a required field`,
          validation: ["required"],
          label: COST_METRIC,
        },
      }));
    } else {
      setError((prevState: typeof errorInitail) => ({
        ...prevState,
        ["costMetric"]: {
          isError: false,
          message: "",
          validation: ["required"],
          label: COST_METRIC,
        },
      }));
    }
    if (costTypeRequiredError) {
      isValid = false;
    }
    return isValid;
  };

  const handleChange = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = typeof value === "string" ? ltrimString(value) : value;
    if (name === "CostMetricNSR" || name === "cost" || name === "Indexation") {
      val = val.replace(/[^0-9.]/g, "");
      val = val.replace(/(\..*)\./g, "$1");

      if (formatUSDWithCommas(val).length > 9) {
        if (val.endsWith(".")) {
          val = val.slice(0, -1);
        } else if (val.includes(".")) {
          const [intPart, decPart] = val.split(".");
          val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
        } else {
          val = val.slice(0, 8);
        }
      }
      if (val && val.includes(".")) {
        const [intPart, decPart] = val.split(".");
        val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
      }
    }

    if (
      name === "skuNumber" ||
      name === "skuNumber_2" ||
      name === "skuNumber_3"
    ) {
      val = val.toUpperCase();
      // auto focus on next input for skuNumber and skuNumber_2
      if (name === "skuNumber" && val.length === 1) {
        const input = document.getElementsByName(
          "skuNumber_2",
        )[0] as HTMLInputElement;
        input.focus();
      }
      if (name === "skuNumber_2" && val.length === 1) {
        const input = document.getElementsByName(
          "skuNumber_3",
        )[0] as HTMLInputElement;
        input.focus();
      }
    }
    if (name === "chargingIncrement") {
      setFormFields((prevFields: CreateSkuFormValues) => {
        if (prevFields.chargingIncrement === "onetime" && val !== "onetime") {
          return {
            ...prevFields,
            [name]: val,
            minimumSelectableIncrement: "",
          };
        }
        if (val === "autotransact") {
          return {
            ...prevFields,
            [name]: val,
            costCategory: "Variable",
            minimumSelectableIncrement: "1",
            skuRelation: [],
            autoProvision: "1",
            returnable: "0",
          };
        }
        if (val === "onetime") {
          return {
            ...prevFields,
            [name]: val,
            costCategory: "Fixed",
            minimumSelectableIncrement: "1",
          };
        }
        return {
          ...prevFields,
          [name]: val,
        };
      });
    }
    if (name === "costCategory") {
      setCostTypeRequiredError(false);
      setFormFields((prevFields: CreateSkuFormValues) => ({
        ...prevFields,
        [name]: val,
        costMetric: "",
        chargingIncrement: "",
      }));
    } else {
      setFormFields((prevFields: CreateSkuFormValues) => ({
        ...prevFields,
        [name]: val,
      }));
    }
    if (name === "autoProvision") {
      if (val === "1" && deploymentApprover.isError) {
        setError((prevState) => ({
          ...prevState,
          deploymentApprover: {
            isError: false,
            message: "",
            validation: [""],
            label: PROVISIONING_TEAM,
          },
        }));
      }
    }
    if (name === "skuShortDescription" && value.length > MAX_LENGTH_SKU_NAME) {
      getSlicedSkuName(name, value);
    }
    validateFormFields(name, val, error, setError, "sku_draft", formFields);
  };

  useEffect(() => {
    // const runAsync = async () => {
    if (chargingIncrement == "autotransact") {
      validateFormFields(
        "costCategory",
        costCategory,
        error,
        setError,
        "sku_draft",
      );
      validateFormFields(
        "minimumSelectableIncrement",
        minimumSelectableIncrement,
        error,
        setError,
        "sku_draft",
      );
      validateFormFields(
        "skuRelation",
        skuRelation,
        error,
        setError,
        "sku_draft",
      );
      validateFormFields(
        "autoProvision",
        autoProvision,
        error,
        setError,
        "sku_draft",
      );
      validateFormFields(
        "returnable",
        returnable,
        error,
        setError,
        "sku_draft",
      );
    }
    if (chargingIncrement == "onetime") {
      validateFormFields(
        "costCategory",
        costCategory,
        error,
        setError,
        "sku_draft",
      );
      validateFormFields(
        "minimumSelectableIncrement",
        minimumSelectableIncrement,
        error,
        setError,
        "sku_draft",
      );
    }
    if (!isEmpty(formFields.costCategory) && isEmpty(formFields.costMetric)) {
      setError((prevState: typeof errorInitail) => ({
        ...prevState,
        ["costMetric"]: {
          isError: true,
          message: `${COST_METRIC}  is a required field`,
          validation: ["required"],
          label: COST_METRIC,
        },
      }));
    } else {
      setError((prevState: typeof errorInitail) => ({
        ...prevState,
        ["costMetric"]: {
          isError: false,
          message: "",
          validation: ["required"],
          label: COST_METRIC,
        },
      }));
    }
  }, [formFields]);

  const handleBlur = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = value.replace(/[^0-9.]/g, ""); // Allow only digits and dot
    val = val.replace(/(\..*)\./g, "$1"); // Only one dot

    if (
      formatUSDWithCommas(val).length > 0 &&
      formatUSDWithCommas(val).length < 9
    ) {
      if (!val.includes(".")) {
        // If no dot, append .00
        val = val + ".00";
      } else {
        const [intPart, decPart] = val.split(".");
        const newInt = intPart || "0";
        const newDec = decPart.padEnd(2, "0").slice(0, 2); // Fill zeros if needed
        val = newInt + "." + newDec;
      }
    }

    setFormFields((prevFields: CreateSkuFormValues) => ({
      ...prevFields,
      [name]: val,
    }));

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
  };

  const {
    skuNumber,
    skuNumber_2,
    skuNumber_3,
    skuShortDescription,
    skuLongDescription,
    costCategory,
    chargingIncrement,
    returnable,
    costMacroCategory,
    minimumSelectableIncrement,
    cost,
    skuRelation,
    autoProvision,
    commercialStatus,
    billingType,
    costMetric,
    CostMetricNSR,
    Indexation,
  } = formFields;

  useEffect(() => {
    if (!isEmpty(costMetric) && isEmpty(costCategory)) {
      setFormFields((prevFields: CreateSkuFormValues) => {
        return {
          ...prevFields,
          costMetric: "",
        };
      });
      setCostTypeRequiredError(true);
    }
  }, [costMetric]);

  const isNotAutoProvisioned = autoProvision === "0";

  const handleDeploymentApproverChange = (type: string) => {
    const isError =
      type === "remove" &&
      isNotAutoProvisioned &&
      deploymentApproverList?.length === 1;
    setError((prevState) => ({
      ...prevState,
      deploymentApprover: {
        isError,
        message: "",
        validation: [isError ? "required" : ""],
        label: PROVISIONING_TEAM,
      },
    }));
  };

  const handleSave = async (statusType: string) => {
    try {
      const validFormStatus = await isValidForm(statusType);
      if (!validFormStatus) {
        return;
      }
      const isError = Object.values(error).some(
        (fieldError) => fieldError.isError === true,
      );
      if (isError) {
        return;
      }
      const getSelectedCostCategory = CostCategory.filter(
        (item: {
          CostMetric: string;
          CostMetricType: string;
          Name: string;
          CostMetricCd: string;
        }) =>
          item.CostMetric === costMetric &&
          item.CostMetricType === costCategory,
      );

      const getSelectedCostCategoryCd =
        getSelectedCostCategory[0]?.CostMetricCd;
      const CostMetricCd = getSelectedCostCategoryCd || "";
      const GlobalRiskMgr = globalRiskMng;
      const LocalRiskMgr = localRiskMng;
      const ProductApprover = productApproverList;
      const DeploymentApprover = deploymentApproverList;
      let costMacroCategoryArr = [];
      if (costMacroCategory.length > 0) {
        costMacroCategoryArr = costMacroCategory.filter(
          (item: any) => item !== "all",
        );
      }

      const skuFormData: CreateSkuFormValues = {
        skuNumber: `${productId}-${skuTotalNumber}-${skuNumber}${skuNumber_2}${skuNumber_3}`,
        productId: productId || "",
        skuShortDescription,
        skuLongDescription,
        CostMetricCd,
        chargingIncrement,
        returnable: returnable === "" ? null : returnable,
        costMacroCategory: costMacroCategoryArr,
        minimumSelectableIncrement:
          minimumSelectableIncrement === "" ? null : minimumSelectableIncrement,
        cost,
        skuRelation,
        autoProvision: autoProvision === "" ? null : autoProvision,
        commercialStatus: statusType,
        billingType,
        ProductSkuNum: Number(skuTotalNumber),
        CostMetricNSR: CostMetricNSR === "" ? null : Number(CostMetricNSR),
        GlobalRiskMgr: GlobalRiskMgr || [],
        LocalRiskMgr: LocalRiskMgr || [],
        ProductApprover: ProductApprover || [],
        DeploymentApprover: DeploymentApprover || [],
        Indexation: Indexation === "" ? null : parseFloat(Indexation),
        ConsumptionMgr: consumptionManagerList,
      };
      if (statusType === "sku_submitted") {
        setIsSubmitSKULoading(true);
      } else {
        setIsSaveSKULoading(true);
      }
      const response = await dispatch(
        createSku(mapSKuDataWithApi(skuFormData)),
      );
      if (response.payload.Status === "success") {
        setIsSubmitSKULoading(false);
        setIsSaveSKULoading(false);
        dispatch(resetCreateSkuState());
        onSave(response.payload);
        setShowSuccessPage(true);
      } else {
        setIsSubmitSKULoading(false);
        setIsSaveSKULoading(false);
      }
      // Add any additional logic here if needed
    } catch (error) {
      setIsSubmitSKULoading(false);
      setIsSaveSKULoading(false);
      console.log("Error in handleSave", error);
      console.log("createSKUData", createSKUData);
    }
  };

  if (isconfigLoadingAPi || isSkuListLoadingAPi) {
    return <Loader />;
  }
  if (configErrorAPi) {
    return <div className="error">Error fetching data</div>;
  }
  if (!configData) {
    return <div className="error">No data available</div>;
  }

  const {
    CostCategory,
    CommercialStatus,
    CostMacroCategory,
    ChargingIncrement,
  } = configData;

  const uniqueCostCategory: string[] = [];
  const CostCategoryTypeOptions: { label: string; value: string }[] = [
    {
      label: COST_CATEGORY_PLACEHOLDER,
      value: "",
    },
  ];

  const CostMetricOptions: { label: string; value: string }[] = [
    {
      label: COST_METRIC_PLACEHOLDER,
      value: "",
    },
  ];

  CostCategory?.forEach(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    (item: {
      Name: string;
      CostMetricType: string;
      CostMetricCd: string;
      CostMetric: string;
    }) => {
      if (costCategory === "" || costCategory === item.CostMetricType) {
        CostMetricOptions.push({
          label: item.CostMetric,
          value: item.CostMetric,
        });
      }
      if (uniqueCostCategory.includes(item.CostMetricType) === false) {
        uniqueCostCategory.push(item.CostMetricType);
        CostCategoryTypeOptions.push({
          label: item.CostMetricType,
          value: item.CostMetricType,
        });
      }
    },
  );

  const CommercialStatusFilter = CommercialStatus?.filter(
    (item: { Name: string; StatusCd: string; StatusType: string }) =>
      item.StatusType === "sku",
  );

  const CommercialStatusOptions = CommercialStatusFilter?.map(
    (item: { Name: string; StatusCd: string }) => ({
      label: item.Name,
      value: item.StatusCd,
    }),
  );

  const billingTypeFilter = CommercialStatus?.filter(
    (item: { Name: string; StatusCd: string; StatusType: string }) =>
      item.StatusType === "skubill",
  );

  const BillingTypeOptions = billingTypeFilter?.map(
    (item: { Name: string; StatusCd: string }) => ({
      label: item.Name,
      value: item.StatusCd,
    }),
  );

  const CostMacroCategoryOptions = CostMacroCategory?.map(
    (item: { Name: string; CostMacroCategoryCd: string }) => ({
      label: item.Name,
      value: item.CostMacroCategoryCd,
    }),
  );

  const ChargingIncrementOptions = ChargingIncrement?.filter(
    (item: { CostIntervalCd: string }) => {
      if (costCategory === "Variable") {
        return item.CostIntervalCd !== "onetime";
      }
      if (costCategory === "Fixed") {
        // Hide "autotransact"
        return item.CostIntervalCd !== "autotransact";
      }
      return true;
    },
  ).map((item: { Name: string; CostIntervalCd: string }) => ({
    label: item.Name,
    value: item.CostIntervalCd,
  }));

  const skuListDataParentOnly = skuListData?.Result?.filter((items: any) => {
    return items.SkuRelation.length === 0;
  });

  const skuRelationOption = skuListDataParentOnly?.map(
    (item: { Name: string; SkuId: string }) => ({
      label: item.Name,
      value: item.SkuId,
    }),
  );

  let skuErrorDisplay = false;
  if (
    skuNumberError.isError === true ||
    skuNumber_2Error?.isError === true ||
    skuNumber_3Error.isError === true
  ) {
    skuErrorDisplay = true;
  }

  let skuErrorMessage = "";
  if (skuNumberError.isError) {
    skuErrorMessage = skuNumberError.message;
  } else if (skuNumber_2Error.isError) {
    skuErrorMessage = skuNumber_2Error.message;
  } else if (skuNumber_3Error.isError) {
    skuErrorMessage = skuNumber_3Error.message;
  } else {
    skuErrorMessage = "";
  }

  return (
    <div className="create-sku-modal">
      <MotifTheme variant={"light"}></MotifTheme>
      <MotifModal
        show={show}
        onClose={() => {
          setShow(false);
          setFormFields(initialValues);
          setError(errorInitail);
          setShowSuccessPage(false);
          dispatch(resetCreateSkuState());
          setLocalRiskMng([]);
          setGlobalRiskMng([]);
          setProductApproverList([]);
          setDeploymentApproverList([]);
          setConsumptionManagerList([]);
        }}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
        className="createSkuModal"
      >
        {showSuccessPage ? (
          <>
            <MotifModalHeader>{""}</MotifModalHeader>
            <MotifModalBody>
              <div className="motif-row center-screen">
                <div className="motif-col-lg-5">
                  <div className="successContainer">
                    <div className="success-heading">Congratulations !!</div>
                    <div className="success-content">
                      Congratulations!! Your product SKUs have been added. Click
                      on “My Products” to view the Product’s page
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row center-screen">
                <div className="motif-col-lg-5">
                  <div className="ctProductPreview-button-container">
                    <MotifButton
                      size="medium"
                      type="submit"
                      variant="secondary"
                      className="success-myproduct-button"
                      onClick={handleMyProductBtnClick(productId)}
                    >
                      {"My Products"}
                    </MotifButton>
                  </div>
                </div>
              </div>
            </MotifModalBody>
            <MotifModalFooter>
              <></>
            </MotifModalFooter>
          </>
        ) : (
          <>
            <MotifModalHeader>{"SKUs"}</MotifModalHeader>
            <MotifModalBody>
              {hasAnyProductError && (
                <div className="motif-row error-grid">
                  <div className="motif-col-lg-12">
                    <NotificationGrid
                      show={true}
                      message={MISSING_FIELDS_ERROR}
                      type="error"
                      subMessage={SKU_CREATION_MESSAGE}
                    />
                  </div>
                </div>
              )}
              {skuListErrorAPi && (
                <>
                  <div className="motif-row error-grid">
                    <div className="motif-col-lg-12">
                      <NotificationGrid
                        show={true}
                        message={"Unexpected error occurred on listing SKUs."}
                        type="error"
                      />
                    </div>
                  </div>
                </>
              )}

              {createSKUErrorAPi && (
                <>
                  <div className="motif-row error-grid">
                    <div className="motif-col-lg-12">
                      <NotificationGrid
                        show={true}
                        message={createSKUErrorAPi}
                        type="error"
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="motif-row heading">
                <div className="motif-col-lg-12">
                  <div className="title">SKU Details</div>
                </div>
              </div>
              <div className="motif-row form-item-row single-row">
                <div className="motif-col-lg-2  form-item">
                  <div className="label">
                    {EMPIRE_CODE_PLACEHOLDER}
                    <span className="required">*</span>
                  </div>
                </div>
                <div className="motif-col-lg-2  form-item skuNumbertext">
                  {`${productId}-${skuTotalNumber}-`}
                </div>
                <div className="motif-col-lg-1  form-item skuNumberRow">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        name={"skuNumber"}
                        value={skuNumber}
                        placeholder={""}
                        error={skuNumberError}
                        readonly={false}
                        hideClearButton={true}
                        className="skuNumber"
                      />
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg-1  form-item skuNumberRow">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        name={"skuNumber_2"}
                        value={skuNumber_2}
                        placeholder={""}
                        error={skuNumber_2Error}
                        readonly={false}
                        hideClearButton={true}
                        onKeyDown={(
                          e: React.KeyboardEvent<HTMLInputElement>,
                        ) => {
                          if (e.key === "Backspace" && skuNumber_2 === "") {
                            const input = document.getElementsByName(
                              "skuNumber",
                            )[0] as HTMLInputElement;
                            input.focus();
                          }
                        }}
                        className="skuNumber"
                      />
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg-1  form-item skuNumberRow">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        name={"skuNumber_3"}
                        value={skuNumber_3}
                        placeholder={""}
                        error={skuNumber_3Error}
                        readonly={false}
                        hideClearButton={true}
                        onKeyDown={(e) => {
                          if (e.key === "Backspace" && skuNumber_3 === "") {
                            const input = document.getElementsByName(
                              "skuNumber_2",
                            )[0] as HTMLInputElement;
                            input.focus();
                          }
                        }}
                        className="skuNumber"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {skuErrorDisplay === true ? (
                <div className="motif-row form-item-row single-row sku-error-row">
                  <div className="motif-col-lg-3  form-item"></div>
                  <div className="motif-col-lg-9  form-item">
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-example"
                    >
                      {skuNumberError || skuNumber_2Error || skuNumber_3Error
                        ? skuErrorMessage
                        : ""}
                    </MotifErrorMessage>
                  </div>
                </div>
              ) : null}

              <div className="motif-row form-item-row single-row">
                <div className="motif-col-lg-2  form-item">
                  <div className="label">
                    {SKU_NAME}
                    <span className="required">*</span>
                  </div>
                </div>
                <div className="motif-col-lg-10  form-item">
                  <div className="value">
                    <div className="inputField">
                      <InputBox
                        ariaLabel=""
                        label=""
                        onChange={handleChange}
                        name={"skuShortDescription"}
                        value={skuShortDescription}
                        placeholder={SKU_NAME}
                        error={skuShortDescriptionError}
                        readonly={false}
                        hideClearButton={true}
                      />
                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-example"
                      >
                        {skuShortDescriptionError
                          ? skuShortDescriptionError.message
                          : ""}
                      </MotifErrorMessage>
                      <div className="helper-text">
                        <div>{SKU_NAME_HELPER_TEXT}</div>
                        <div>{`${skuShortDescription?.length ?? 0} /64`}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row single-row">
                <div className="motif-col-lg-2 form-item">
                  <span className="label">
                    {SKU_LONG_DESCRIPTION}
                    <span className="required">*</span>
                  </span>
                </div>

                <div className="motif-col-lg-10  form-item">
                  <div className="value">
                    <div className="inputField">
                      <RichTextEditor
                        name={"skuLongDescription"}
                        value={skuLongDescription}
                        handleChange={handleChange}
                        placeholder={SKU_LONG_DESCRIPTION}
                      />

                      <MotifErrorMessage
                        aria-live="assertive"
                        role="alert"
                        id="aria-error-example"
                      >
                        {skuLongDescriptionError
                          ? skuLongDescriptionError.message
                          : ""}
                      </MotifErrorMessage>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row heading costing-label">
                <div className="motif-col-lg-12">
                  <div className="title">Costing</div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {COST_CATEGORY}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={sortOptions(CostCategoryTypeOptions)}
                            value={costCategory}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "costCategory",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={COST_CATEGORY_PLACEHOLDER}
                            multiple={false}
                            placeholder={COST_CATEGORY_PLACEHOLDER}
                            disabled={
                              chargingIncrement === "onetime" ||
                              chargingIncrement === "autotransact"
                            }
                          />
                          {costCategoryError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {costCategoryError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {COST_INTERVAL}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={sortOptions(ChargingIncrementOptions)}
                            value={chargingIncrement}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "chargingIncrement",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={COST_INTERVAL_PLACEHOLDER}
                            multiple={false}
                            placeholder={COST_INTERVAL_PLACEHOLDER}
                          />
                          {chargingIncrementError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {chargingIncrementError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {RETURNABLE}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={[
                              { label: "Yes", value: "1" },
                              { label: "No", value: "0" },
                            ]}
                            value={returnable}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "returnable",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={RETURNABLE_PLACEHOLDER}
                            multiple={false}
                            placeholder={RETURNABLE_PLACEHOLDER}
                            disabled={chargingIncrement === "autotransact"}
                          />
                          {returnableError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {returnableError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {COST_MACRO_CATEGORY}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <MultiSelect
                            options={CostMacroCategoryOptions}
                            value={costMacroCategory}
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "costMacroCategory",
                                  value: selectedOption,
                                },
                              })
                            }
                            placeholder={COST_MACRO_CATEGORY_PLACEHOLDER}
                            hasSelectAll={true}
                            selectAllLabel="Select all"
                            selectAllValue="all"
                            theme="ch-light"
                          />
                          {costMacroCategoryError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {costMacroCategoryError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {MINIMUM_SELECTABLE_INCREMENT}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <InputBox
                            ariaLabel=""
                            label=""
                            onChange={handleChange}
                            name={"minimumSelectableIncrement"}
                            value={
                              chargingIncrement === "autotransact" &&
                              costCategory === "Variable"
                                ? "1"
                                : minimumSelectableIncrement
                            }
                            placeholder={MINIMUM_SELECTABLE_INCREMENT}
                            error={minimumSelectableIncrementError}
                            readonly={
                              chargingIncrement === "onetime" ||
                              chargingIncrement === "autotransact"
                            }
                            hideClearButton={true}
                          />
                          {minimumSelectableIncrementError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {minimumSelectableIncrementError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {COST}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <InputBox
                            name={"cost"}
                            ariaLabel=""
                            label={COST}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={formatUSDWithCommas(cost)}
                            hideClearButton={true}
                            error={costError}
                            placeholder={""}
                            prefix="$USD"
                          />
                          {costError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {costError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg hide">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">{SKU_RELATION}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={skuRelationOption ?? []}
                            value={skuRelation}
                            onChange={(selectedOption) =>
                              handleChange({
                                target: {
                                  name: "skuRelation",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={SKU_RELATION_PLACEHOLDER}
                            multiple={true}
                            placeholder={SKU_RELATION_PLACEHOLDER}
                            disabled={chargingIncrement === "autotransact"}
                          />
                          {skuRelationError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {skuRelationError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {AUTO_PROVISION}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={[
                              { label: "Yes", value: "1" },
                              { label: "No", value: "0" },
                            ]}
                            value={autoProvision}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "autoProvision",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={AUTO_PROVISION_PLACEHOLDER}
                            multiple={false}
                            placeholder={AUTO_PROVISION_PLACEHOLDER}
                            disabled={chargingIncrement === "autotransact"}
                          />
                          {autoProvisionError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {autoProvisionError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {BILLING_TYPE_STATUS}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={sortOptions(BillingTypeOptions) || []}
                            value={billingType}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "billingType",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={BILLING_TYPE_STATUS}
                            multiple={false}
                            placeholder={BILLING_TYPE_STATUS}
                          />
                          {billingTypeError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {billingTypeError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">
                        {COST_METRIC}
                        <span className="required">*</span>
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <SelectBox
                            options={sortOptions(CostMetricOptions) || []}
                            value={costMetric}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange={(selectedOption: any) =>
                              handleChange({
                                target: {
                                  name: "costMetric",
                                  value: selectedOption,
                                },
                              })
                            }
                            searchPlaceholder={COST_METRIC}
                            multiple={false}
                            placeholder={COST_METRIC}
                          />
                          {costTypeRequiredError && (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {REQUIRED_COST_METRICS_AVIALBLE}
                            </MotifErrorMessage>
                          )}
                          {costMetricError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {costMetricError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">{NSR}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <InputBox
                            name={"CostMetricNSR"}
                            ariaLabel=""
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={formatUSDWithCommas(CostMetricNSR)}
                            hideClearButton={true}
                            prefix="$USD"
                            placeholder={""}
                          />
                          {CostMetricNSR ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {CostMetricNSRError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item">
                      <div className="label">{INDEXATION}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField indexation-input-field">
                          <InputBox
                            name={"Indexation"}
                            ariaLabel=""
                            onChange={handleChange}
                            value={Indexation}
                            suffix={Indexation ? "%" : ""}
                            hideClearButton={true}
                            placeholder={INDEXATION_PLACEHOLDER}
                            onBlur={handleBlur}
                          />
                          {IndexationError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              {IndexationError.message}
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg"></div>
                <div className="motif-col-lg hide"></div>
              </div>
              <div className="motif-col-lg">
                <div className="motif-row left-content">
                  <div className="motif-col-lg-4 form-item hide">
                    <div className="label">
                      {COMMERCIAL_STATUS}
                      <span className="required">*</span>
                    </div>
                  </div>
                  <div className="motif-col-lg-8 form-item hide">
                    <div className="value">
                      <div className="inputField">
                        <SelectBox
                          options={sortOptions(CommercialStatusOptions) || []}
                          value={commercialStatus}
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onChange={(selectedOption: any) =>
                            handleChange({
                              target: {
                                name: "commercialStatus",
                                value: selectedOption,
                              },
                            })
                          }
                          searchPlaceholder={COMMERCIAL_PLACEHOLDER}
                          multiple={false}
                          placeholder={COMMERCIAL_PLACEHOLDER}
                        />
                        {commercialStatusError ? (
                          <MotifErrorMessage
                            aria-live="assertive"
                            role="alert"
                            id="aria-error-primaryList"
                          >
                            {commercialStatusError.message}
                          </MotifErrorMessage>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row heading costing-label">
                <div className="motif-col-lg-12">
                  <div className="title">{ORDER_ACKNOWLEDGEMENT}</div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item label-item">
                      <div className="label">{GLOBAL_RISK_MANAGER}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <UserSearchSelect
                            proxyOwners={globalRiskMng}
                            name={"globalRiskManager"}
                            setUserSearchSelect={setGlobalRiskMng}
                            readOnly={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item label-item">
                      <div className="label">{LOCAL_RISK_MANAGER}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <UserSearchSelect
                            proxyOwners={localRiskMng}
                            setUserSearchSelect={setLocalRiskMng}
                            name={"localRiskManager"}
                            readOnly={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item label-item">
                      <div className="label">{PRODUCT_APPROVER}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <UserSearchSelect
                            proxyOwners={productApproverList}
                            setUserSearchSelect={setProductApproverList}
                            name={"productApprover"}
                            readOnly={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg">
                  <div className="motif-row right-content">
                    <div className="motif-col-lg-4 form-item label-item">
                      <div className="label">
                        {PROVISIONING_TEAM}
                        {isNotAutoProvisioned && (
                          <span className="required">*</span>
                        )}
                      </div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <UserSearchSelect
                            proxyOwners={deploymentApproverList}
                            setUserSearchSelect={setDeploymentApproverList}
                            name={"deploymentApprover"}
                            readOnly={false}
                            callBack={handleDeploymentApproverChange}
                          />
                          {deploymentApprover.isError ? (
                            <MotifErrorMessage
                              aria-live="assertive"
                              role="alert"
                              id="aria-error-primaryList"
                            >
                              You must enter at least one email for the
                              Provisioning Team
                            </MotifErrorMessage>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="motif-row form-item-row double-row">
                <div className="motif-col-lg">
                  <div className="motif-row">
                    <div className="motif-col-lg-4 form-item label-item">
                      <div className="label">{CONSUMPTION_MANAGER}</div>
                    </div>
                    <div className="motif-col-lg-8 form-item">
                      <div className="value">
                        <div className="inputField">
                          <UserSearchSelect
                            proxyOwners={consumptionManagerList}
                            setUserSearchSelect={setConsumptionManagerList}
                            name={"consumptionManager"}
                            readOnly={false}
                            placement={"top"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-col-lg" />
              </div>

              {hasAnyProductError && (
                <div className="prevent-sku-submission ">
                  <MotifIcon
                    iconFunction={IconoirInfoCircle}
                    size="20"
                    title="Order Bundle"
                    fill="#EA011D"
                  />
                  <span>{PREVENT_SKU_SUBMISSION}</span>
                </div>
              )}
            </MotifModalBody>
            <MotifModalFooter>
              <MotifButton
                variant={"secondary"}
                onClick={() => {
                  setShow(false);
                  setFormFields(initialValues);
                  setError(errorInitail);
                  setLocalRiskMng([]);
                  setGlobalRiskMng([]);
                  setProductApproverList([]);
                  setDeploymentApproverList([]);
                  setConsumptionManagerList([]);
                }}
              >
                Cancel
              </MotifButton>
              <MotifButton
                variant={"secondary"}
                onClick={() => handleSave("sku_draft")}
                loading={isSaveSKULoading}
                disabled={isSaveSKULoading}
              >
                {"Save as Draft"}
              </MotifButton>
              <MotifButton
                variant={"primary"}
                onClick={() => handleSave("sku_submitted")}
                loading={isSubmitSKULoading}
                disabled={isSubmitSKULoading || hasAnyProductError}
              >
                Submit
              </MotifButton>
            </MotifModalFooter>
          </>
        )}
      </MotifModal>
    </div>
  );
};

export default CreateSkuModal;
